<div 
  class="explore-container focusable-container" 
  [ngClass]="{ 'lang-tamil': currentLang === 'ta' }"
>
  <h2 class="heading" [style]="'fontSize.36' | translate">{{ "explore_header" | translate }}</h2>
  <p class="subtext" [style]="'fontSize.28' | translate" [innerHTML]="'explore_desc' | translate"></p>
  <app-icon-button
    [label]="'explore_title' | translate"
    [mode]="'normal'"
    class="explore-button"
    (clicked)="onExploreClick()"
    (keydown.ArrowLeft)="onExploreLeft()"
    (keydown.ArrowUp)="onExploreUp()"
  ></app-icon-button>
</div>
